import Cons from '@/constants.json'

window.Cons = Cons;

import Vue from 'vue'
import Vuex from 'vuex'
import Store from '@/store'
import VueCookie from 'vue-cookie'
import createPersistedState from 'vuex-persistedstate'
import { Message, Notice, Modal } from 'iview'
import * as API from '@/endpoints'
import Axios from 'axios'
import brand from '@/store/modules/brand'
import base from '@/store/modules/base'
import user from '@/store/modules/user'
import gallery from '@/store/modules/gallery'
import resource from '@/store/modules/resource'
import nearby from '@/store/modules/nearby'
import directory from '@/store/modules/directory'
import menu from '@/store/modules/menu'
import feed from '@/store/modules/feed'
import publicModule from '@/store/modules/publicModule'
import onBoarding from '@/store/modules/onBoarding'
import alliance from '@/store/modules/alliance'
import org from '@/store/modules/org'
import faq from '@/store/modules/faq'
import feature from '@/store/modules/feature'
import share from '@/store/modules/share'
import events from '@/store/modules/events'
import artwork from '@/store/modules/artwork'
import answer from '@/store/modules/answer'
import notification from '@/store/modules/notification'
import donation from '@/store/modules/donation'
import systemAlert from '@/store/modules/systemAlert'
import publicProfile from '@/store/modules/publicProfile'
import statistics from '@/store/modules/statistics'
import follow from '@/store/modules/follow'
import library from '@/store/modules/library'
import guest from '@/store/modules/guest'
import packages from '@/store/modules/packages'
import branding from '@/store/modules/branding'
import careteam from '@/store/modules/careteam'
import points from '@/store/modules/points'
import addon from '@/store/modules/addon'

import router from '@/router'
import { stat } from 'fs';

Vue.use(Vuex)

let store = new Vuex.Store({
  plugins: [createPersistedState({
    key: process.env.VUE_APP_API
  })],
  state: {
    url: window.Cons[0].PATHS,
    mobileView: {},
    baseImageUrl: process.env.VUE_APP_BASE_IMAGE_URL,
    isMobile: false,
    gmapLoaded: null,
    enableNotifButton: false,
    enableNotifIOSButton: false,
    enabledNotifSubscription: false,
    notifSubscription: null,
    supportPush: false,
    isOnline: navigator.onLine,
    menuItems: {},
    isMenuItemLoading: false,
    currentTab: 0,
    dynamicPageTitle: null,
    isFetchingLinkLoading: false,
    dynamicUrl: null,
    idleTimeEnable: false,
    idleTime: 15000,
  },
  getters: {
    getPageTitle(state) {
      return state.dynamicPageTitle
    },
    getDynamicUrl(state){
      return state.dynamicUrl
    },
    getIsFetchingUrlLoader(state){
      return state.isFetchingLinkLoading
    }
  },
  modules: {
    addon,
    statistics,
    gallery,
    org,
    points,
    guest,
    faq,
    feature,
    base,
    brand,
    user,
    nearby,
    directory,
    resource,
    menu,
    feed,
    library,
    publicModule,
    alliance,
    onBoarding,
    share,
    events,
    artwork,
    answer,
    notification,
    branding,
    donation,
    systemAlert,
    publicProfile,
    follow,
    packages,
    careteam
  },
  mutations: {
    setIdleTimer(state, v) {
      state.idleTime = (!v.minutes || v.minutes == 0) ? 10 : v.minutes;
      state.idleTimeEnable = v.enabled;
    },
    setIsFetchingUrlLoader(state, v){
      state.isFetchingLinkLoading = v;
    },
    setDynamicUrl(state, v){
      state.dynamicUrl = v
    },
    doBeep(state, v) {
      var sound = document.getElementById("AlertTone");
      if (!sound) return;
      if (v) {
        sound.play();
      } else {
        sound.stop();
      }
    },
    setPageTitle(state, v) {
      state.dynamicPageTitle = v
    },
    setCurrentTab(state, v) {
      state.currentTab = v
    },
    setPushSupport(state, v) {
      state.supportPush = v
    },
    setnotifSubscription(state, v) {
      state.notifSubscription = v
    },
    setNotificationSubscribe(state, v) {
      Vue.set(state, 'enabledNotifSubscription', v)
    },
    setEnableNotifButton(state, v) {
      Vue.set(state, 'enableNotifButton', v)
    },
    setEnableNotifIOSButton(state, v) {
      Vue.set(state, 'enableNotifIOSButton', v)
    },
    hitOffline(state, v) {
      Message.destroy()
      Message.info({
        content: 'You must be online to navigate to this page.',
        duration: 3
      });
    },
    hitCheckpoint(state, v) {
      Modal.confirm({
        title: "Wait!",
        closable: false,
        maskClosable: false,
        okText: 'Login/Register',
        cancelText: '',
        content: 'Kindly login or register to get access to this page.',
        onOk: () => {
          router.push({ path: '/' + router.currentRoute.params.brandSlug + '/login?type=signin' });
        },
        onCancel: () => {
          router.push({ path: '/' + router.currentRoute.params.brandSlug + '/login?type=signin' });
        }
      })
    },
    isMobile(state, v) {
      Vue.set(state, 'isMobile', v)
    },
    mapLoaded(state, v) {
      Vue.set(state, 'gmapLoaded', v)
    },
    setMobileViewData(state, v) {
      Vue.set(state, 'mobileView', v)
    },
    showNotice(state, v) {
      if (v.type === 'info') {
        Message.info(v.desc)
      }
      if (v.type === 'success') {
        Message.success(v.desc)
      }
      if (v.type === 'warning') {
        Message.warning(v.desc);
      }
      if (v.type === 'error') {
        Message.error(v.desc)
      }
    }
  },
  actions: {
    async getActionMenu({ commit, dispatch, state }) {
      if (!localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')) return false;
      state.isMenuItemLoading = true
      let data = await dispatch('user/getBrandActionMenu', {
        brand_id: Cons[0].BRAND_ID
      }, { root: 1 });
      state.isMenuItemLoading = false
      state.menuItems = data;
      // console.log("{}", state.menuItems.pages)

      // .then( res => {
      //   state.menuItems = res.data;
      //   return Promise.resolve(res.data)
      // }, error => {
      //   dispatch('exceptionHandling', { _err: error }, { root: 1 })
      //   return Promise.reject(error)
      // })

      // return new Promise((resolve,reject) => {
      //   Axios.get(API.endpoints.careplan + '/' + window.Cons[0].GROUP_ID['do_action_menu'])
      //     .then( res => {
      //       state.menuItems = res.data;
      //       resolve(res.data)
      //     }, error => {
      //       dispatch('exceptionHandling', { _err: error }, { root: 1 })
      //       reject(error)
      //     })
      // })
    },
    pushRegisterDevice({ commit }, token) {
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.base + '/device/registration', {
          registration_id: token,
          device_id: "random",
          api_key: "random"
        }).then(res => {
          resolve(res.data)
        }, error => {
          reject(error)
        })
      })
    },
    ErrorHandling({ dispatch, commit, state }, { _err }) {
      let errMsg = 'Error occured.';

      if (_err && _err.response &&
        _err.response.status &&
        _err.response.status == 400) {
        if (_err.response.data.error.code == 0) {
          if (_err.response.data.error.message == 'Must provide authorization header!')
            return false;
          Message.warning({
            content: _err.response.data.error.message,
            duration: 5,
            closable: true
          });
        } else if (_err.response.data.error.code == 400) {
          if (_err.response.data.error.message != "Mobile already in use!"){
            Message.warning({
              content: _err.response.data.error.message,
              duration: 5,
              closable: true
            });
          }
          return false;
        }
        return false;
      }

      if (_err && _err.response &&
        _err.response.status &&
        _err.response.status === 401) {
        if (_err.changePass) return false;
        if ((router.history.current.path == '/login')) {
          Message.error({
            content: _err.response.data.error.message,
            duration: 5,
            closable: true
          });
          return false;
        }
        let mCookie = localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
        let uCookie = JSON.parse(mCookie)
        Store.dispatch('base/refreshToken', { refreshToken: uCookie.refresh_token, forceReload: true })
        Store.dispatch('base/eventHit', {
          eventCategory: _err.response.request.responseURL,
          eventAction: "delete cookie" + ' - Unauthorized - index -' + _err.response.config.headers.Authorization,
          eventLabel: 'delete cookie'
        })
        return false;
      }
    },
    exceptionHandling({ dispatch, commit, state }, { _err }) {
      dispatch('ErrorHandling', { _err });
      return false;
    },
    async getDynamicUrl(context, payload) {
      try {
        // context.state.isFetchingLinkLoading = true;
        context.commit('setIsFetchingUrlLoader', true);
        let res = await Axios.get(API.endpoints.base + '/firebase/dynamic/link?url=' + encodeURIComponent(payload) + '&brand_id=' + Cons[0].BRAND_ID)
        if (res.status === 200){
          context.commit('setDynamicUrl', res.data.url);
          return Promise.resolve(res.data);
        }
      } catch (e) {
        context.commit('setIsFetchingUrlLoader', false);
        return Promise.reject(e);
      } finally {
        // context.state.isFetchingLinkLoading = false;
        context.commit('setIsFetchingUrlLoader', false);
      }
    }
  }
})

/*
We will request a check status every 5 seconds
*/
// let notificatonStatus = function () {
//   setTimeout(() => {
//     if ( VueCookie.get(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE') && store.state.user.info && store.state.user.info.user_type !== 'guest') {
//       store.dispatch('notification/checkStatus').then(() => {
//         notificatonStatus()
//       }).catch(() => notificatonStatus())
//     } else {
//       notificatonStatus()
//     }
//   }, 20000)
// }

// notificatonStatus()

export default store
